module.exports = __webpack_public_path__ + "triacomtecnologia/static/media/everyBusiness.ae624317.png";